const config = {
    //apiBaseUrl: 'http://localhost:5043/api', // Базовый URL API
    apiBaseUrl: 'https://apitag.paragraf.spb.ru/api', // Базовый URL API

    sectionNames: {
        common: 'Общие сведения',
        struct: 'Структура',
        document: 'Документы',
        education: 'Образование',
        edustandarts: 'Стандарты',
        managers: 'Руководство',
        employees: 'Педагоги',
        objects: 'Материальная база',
        grants: 'Стипендии',
        paid_edu: 'Платные услуги',
        budget: 'Финансирование',
        vacant: 'Вакантные места',
        inter: 'Международное сотрудничество',
        catering: 'Питание и охрана здоровья'
    }
};



export default config;